var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiImageSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0801 4.6889C17.8101 4.9454 18.3333 5.64076 18.3333 6.45833V14.7917C18.3333 16.7477 16.7477 18.3333 14.7917 18.3333H6.45833C5.64075 18.3333 4.9454 17.8101 4.6889 17.0801L6.43663 17.083L14.7917 17.0833C16.0573 17.0833 17.0833 16.0573 17.0833 14.7917V6.45833L17.08 6.41585L17.0801 4.6889ZM14.3723 1.66667C15.4079 1.66667 16.2473 2.50613 16.2473 3.54167V14.3723C16.2473 15.4079 15.4079 16.2473 14.3723 16.2473H3.54166C2.50613 16.2473 1.66666 15.4079 1.66666 14.3723V3.54167C1.66666 2.50613 2.50613 1.66667 3.54166 1.66667H14.3723ZM14.3723 2.91667H3.54166C3.19649 2.91667 2.91666 3.19649 2.91666 3.54167V14.3723C2.91666 14.7175 3.19649 14.9973 3.54166 14.9973H14.3723C14.7175 14.9973 14.9973 14.7175 14.9973 14.3723V3.54167C14.9973 3.19649 14.7175 2.91667 14.3723 2.91667Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_139_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 3.16667V14.8333H3.16667V3.16667H14.8333ZM14.8333 1.5H3.16667C2.25 1.5 1.5 2.25 1.5 3.16667V14.8333C1.5 15.75 2.25 16.5 3.16667 16.5H14.8333C15.75 16.5 16.5 15.75 16.5 14.8333V3.16667C16.5 2.25 15.75 1.5 14.8333 1.5ZM10.7833 8.88333L8.28333 12.1083L6.5 9.95L4 13.1667H14L10.7833 8.88333Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_139_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(-1 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiImageSelectIcon);
export default __webpack_public_path__ + "static/media/multiImageSelectIcon.208a5e0574de132ebd067cf513e43189.svg";
export { ForwardRef as ReactComponent };